module.exports = __webpack_public_path__ + "static/media/Circle-on-new-fill.6cdf8902.svg";